module.exports = __webpack_public_path__ + "static/img/female-bg-ar.782192ff.png";